import { render, staticRenderFns } from "./FlashBox.vue?vue&type=template&id=34e30bb6&"
import script from "./FlashBox.vue?vue&type=script&lang=js&"
export * from "./FlashBox.vue?vue&type=script&lang=js&"
import style0 from "./FlashBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports